import { Component, Input, OnChanges } from '@angular/core';
import { HoldingsComponentDCR } from '@ddt-web/config';
import { PortfolioChild, TreeNodeMap, WebUserDataConstants } from '@ddt-web/domain';
import * as sumBy from 'lodash/sumBy';

import { BlendPortfolioUtil } from '../../utils/blend-portfolio.util';

@Component({
	selector: 'ac-view-blend-structure-table',
	templateUrl: './view-blend-structure-table.component.html',
	styleUrls: ['./view-blend-structure-table.component.scss']
})
export class ViewBlendStructureTableComponent implements OnChanges {
	@Input() public portChildrenMap: TreeNodeMap;
	@Input() public rootId: string;

	public readonly PORTFOLIO: string = WebUserDataConstants.TYPE.PORTFOLIO;
	public readonly MODEL_PORTFOLIO_TEXT: string = HoldingsComponentDCR.PORTFOLIO_TYPE_OPTIONS.MODEL_PORTFOLIO;
	public readonly SECURITY_IDENTIFIERS = WebUserDataConstants.SECURITY_IDENTIFIERS;

	public BlendPortfolioUtil = BlendPortfolioUtil;

	public totalWeight: number = 0;
	public rootPortfolio: PortfolioChild = {} as PortfolioChild;

	public ngOnChanges(): void {
		this.rootPortfolio = this.portChildrenMap[this.rootId] || {} as PortfolioChild;
		this.totalWeight = parseFloat((sumBy(this.rootPortfolio.childrenRef, 'weight') || 0).toFixed(9));
	}
}
